module.exports = __webpack_public_path__ + "img/e-Card-Greetings-th.fd69347.png";